module.exports = __webpack_public_path__ + "static/media/INZ1242.a464dcb1.pdf";